// extracted by mini-css-extract-plugin
export default {"image":"ImageCarouselModal_image__xPznL"};